import React, { useState, useMemo, useCallback } from "react";
import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { getCountryFlag } from "../../helperJs/getCountryFlag";
import VirtualizeList from "../../Mycomponent/share/components/virtualize-list";

const DropdownMenu = ({ menuData, handleSelect }) => {
  const [filter, setFilter] = useState("");

  const options = useMemo(
    () =>
      menuData?.data?.filter((value) => {
        const filterText = value.location_name || value;
        return filterText
          .toString()
          .toLowerCase()
          .includes(filter.toLowerCase());
      }),
    [filter, menuData.data]
  );

  const handleDropdownSelect = (value) => {
    setFilter("");
    handleSelect(value);
  };

  const rowRenderer = useCallback(
    ({ key, index, style }) => {
      const item = options[index];
      if (!item) return null;
      const loc_flag = getCountryFlag(item?.location_name || item);

      return (
        <Select.Option
          key={key}
          style={style}
          value={item?.location_name || item}
          className="d-flex"
        >
          {loc_flag && (
            <img
              className="me-2"
              src={loc_flag}
              alt={item?.location_name || item}
              style={{ width: "20px", objectFit: "contain" }}
            />
          )}
          {item?.location_name || item}
          {item?.location_type && (
            <span className="ml-auto">{item.location_type}</span>
          )}
        </Select.Option>
      );
    },
    [options]
  );

  const listHeight = useMemo(
    () => Math.min(options?.length * 35, 220),
    [options]
  );

  return (
    <Flex direction="column">
      <Select
        w="100%"
        className="menu-items"
        value={menuData.value || ""}
        onChange={handleDropdownSelect}
        placeholder={menuData.placeholder || "Select an option"}
        disabled={menuData.disabled || false}
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: menuData.height || "40px",
          }}
          loading={menuData.loading || false}
        />
        <Select.Popper aria-label={"Project options with search"}>
          <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            <div style={{ height: `${listHeight}px`, width: "100%" }}>
              <VirtualizeList
                data={options}
                rowRenderer={rowRenderer}
                rowHeight={35} // Adjust based on your list item height
              />
            </div>
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length} result{options.length > 1 && "s"} found
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                Nothing found
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default DropdownMenu;
